import { toCamelCase } from 'src/utils';

export const getIdFromTableRowKey = (tableRowKey: string) => {
  const changelogId = tableRowKey.substring(tableRowKey.indexOf(':') + 1, tableRowKey.indexOf('/'));
  return Number(changelogId);
};

// Attempts to find a matching translation from the 'list' values in strings file
export const translateFieldValues = ({
  fieldName,
  oldValue,
  newValue,
  listStrings,
}: {
  fieldName: string;
  oldValue: string | null;
  newValue: string | null;
  listStrings: Record<string, { [key: string]: string }>;
}) => {
  const lookupList = {
    infringementFilterCategory: `infringementFilterCategories`,
    operationFilterCategory: `operationFilterCategories`,
    reportFilterCategory: `reportFilterCategories`,
    severity: `severities`,
    aircraftCategory: `aircraftCategories`,
    operatorCategory: `operatorCategories`,
    typeCategory: `typeCategories`,
    correlatedCategory: `correlatedCategories`,
    airtrakFilterCategory: `airtrakFilterCategories`,
    complaintsFilterCategory: `complaintsFilterCategories`,
  };
  const pluralFieldName = lookupList[toCamelCase(fieldName)] || `${toCamelCase(fieldName)}s`;

  const listValues = listStrings[pluralFieldName];

  return {
    translatedOldValue: translateValue(oldValue, listValues),
    translatedNewValue: translateValue(newValue, listValues),
  };
};

// Looks a single changelog value up in its field's translation list. A change that
// creates or clears a field logs a null value, which has no translation.
const translateValue = (value: string | null, listValues: { [key: string]: string }) => {
  if (!value || !listValues) {
    return value;
  }
  // A camel-cased match takes precedence over an exact one
  return listValues[toCamelCase(value)] || listValues[value] || value;
};
